<template>
  <form :class="style['form-wrap']" @submit.prevent="sendForm">
    <text-input
      v-model="restaurantForm.date"
      :read-only="true"
      :icon="iconToday"
      :class-name="'lg'"
      @click="openDatePicker"
    />
    <option-select
      v-show="showMainTime"
      :value="restaurantForm.meal"
      :options="mealOptions"
      :icon="iconClock"
      class-name="lg with-arrow"
      @input="changeMeal"
    />
    <label v-show="showMainTime" :class="style['input-label']"
      >{{ $t('restaurant_form.main_time') }}:
    </label>
    <time-selector
      v-show="showMainTime"
      v-model="restaurantForm.main_time"
      :time-limited="timeLimited"
      :selected-date="restaurantForm.date"
      :selected-meal="restaurantForm.meal"
    />
    <label v-show="showSubTime" :class="style['input-label']"
      >{{ $t('restaurant_form.alternative_times') }}:
      <span :class="style.description">({{ $t('restaurant_form.pick_multiple') }})</span></label
    >
    <time-selector
      v-show="showSubTime"
      v-model="restaurantForm.sub_time"
      :time-limited="timeLimited"
      :selected-date="restaurantForm.date"
      :selected-meal="restaurantForm.meal"
      :multiple="true"
    />
    <div v-if="error" class="error-text">
      <span>{{ error }}</span>
    </div>
    <button v-theme :class="style['btn-pink']" type="submit" :disabled="disabledNext">
      {{ $t('next') }}
    </button>
  </form>
</template>

<script>
import TextInput from 'UtilityComponents/TextInput.vue'
import OptionSelect from 'UtilityComponents/OptionSelect.vue'
import TimeSelector from 'UtilityComponents/TimeSelector.vue'
import { iconToday, iconClock } from 'javascript/Constants'
import style from './scss/_pages.scss'
import { Chat } from 'src/apis'
import { EventBus } from 'ChatWidget/EventBus'
import { inTimeRange } from 'Utilities/TimerHelper'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'
import { useDetailsPageStore } from 'Store/details-page'
import { useFormStore } from 'Store/form'

export default {
  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore(),
      detailsPageStore: useDetailsPageStore(),
      formStore: useFormStore()
    }
  },
  components: {
    TextInput,
    OptionSelect,
    TimeSelector
  },
  data() {
    return {
      timeLimited: this.detailsPageStore.chat.message_rich.time_limited,
      showMainTime: false,
      error: null
    }
  },

  computed: {
    iconToday: () => iconToday,
    iconClock: () => iconClock,
    style: () => style,
    chat() {
      return this.detailsPageStore.chat
    },
    mealOptions() {
      return inTimeRange(this.timeLimited, this.restaurantForm.date, this.createMealOptions)
    },
    restaurantForm() {
      return this.formStore.restaurantForm
    },
    disabledNext() {
      return !(
        this.restaurantForm.date &&
        this.restaurantForm.meal &&
        this.restaurantForm.main_time
      )
    },
    showSubTime() {
      return !this.instantBooking
    },
    date() {
      return this.restaurantForm.date
    },
    instantBooking() {
      return this.detailsPageStore.chat.message_rich.instant_booking
    }
  },
  watch: {
    date() {
      if (this.instantBooking) {
        this.getTimeLimitedByDate()
      }
    }
  },
  created() {
    if (this.instantBooking) {
      this.getTimeLimitedByDate()
    } else {
      this.showMainTime = true
    }
  },
  methods: {
    openDatePicker() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const disabledDates = {
        to: this.chat.message_rich.start_date ? new Date(this.chat.message_rich.start_date) : today,
        ...(this.chat.message_rich.end_date && { from: new Date(this.chat.message_rich.end_date) })
      }
      this.bottomPanelStore.setBottomPanelInputFor('RestaurantForm')
      this.datepickerStore.setDisabledDates(disabledDates)
      this.bottomPanelStore.setBottomPanelComponent('DatePickerPanel')
      this.datepickerStore.setTimeSettings({ currentDate: this.restaurantForm.date })
      this.formStore.setActiveField('date')
    },
    composeReply() {
      const replyArray = [
        `${this.restaurantForm.date}`,
        `${this.$t('restaurant_form.main_time')}: ${this.restaurantForm.main_time}`,
        `${this.$t('restaurant_form.alternative_times')}: ${this.restaurantForm.sub_time.join(
          ', '
        )}`
      ]
      return replyArray.join('\n')
    },
    sendForm() {
      Chat.sendMessage(this.composeReply(), { messageAction: JSON.stringify(this.restaurantForm) })
      this.detailsPageStore.closeDetailsPageShown()
      EventBus.$emit('pageDisabledActionWidget')
    },
    createMealOptions(timeRange) {
      const options = []
      if (timeRange.breakfast)
        options.push({ value: 'breakfast', text: this.$t('restaurant_form.breakfast') })
      if (timeRange.lunch) options.push({ value: 'lunch', text: this.$t('restaurant_form.lunch') })
      if (timeRange.dinner)
        options.push({ value: 'dinner', text: this.$t('restaurant_form.dinner') })
      return options
    },
    changeMeal(value) {
      this.formStore.assignFieldValue({ main_time: null, sub_time: [], meal: value })
    },
    getTimeLimitedByDate() {
      if (this.instantBooking.error) {
        this.error = this.instantBooking.error
        return
      }
      this.error = null
      this.showMainTime = false
      Chat.getRestaurantReservableTimes(
        this.instantBooking.shop_id,
        this.date,
        this.instantBooking.guest_number
      ).then(({ data: reservableTimes, error }) => {
        if (error) {
          this.error = error
        } else {
          this.showMainTime = true
          this.timeLimited = [reservableTimes]
          if (!reservableTimes[this.restaurantForm.meal]) {
            if (reservableTimes.dinner) {
              this.formStore.assignFieldValue({ meal: 'dinner' })
            } else {
              this.formStore.assignFieldValue({ meal: 'lunch' })
            }
          }
        }
        this.formStore.assignFieldValue({ main_time: null })
      })
    }
  }
}
</script>
